import { IAdminCompaniesState } from '../../../types/store/admin/companies';

export const initState: IAdminCompaniesState = {
  pendingCompanies: null,
  isPendingCompaniesLoading: false,
};
